"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateEngine = void 0;
const StatePromise_1 = require("./StatePromise");
class StateEngine {
    // #endregion Properties (4)
    // #region Constructors (1)
    constructor() {
        // #region Properties (4)
        this._fontLoaded = new StatePromise_1.StatePromise();
        this._sessionEngines = {};
        this._viewportEngines = {};
        this._fontLoaded = new StatePromise_1.StatePromise();
    }
    // #endregion Constructors (1)
    // #region Public Static Getters And Setters (1)
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    // #endregion Public Static Getters And Setters (1)
    // #region Public Getters And Setters (3)
    get fontLoaded() {
        return this._fontLoaded;
    }
    get sessionEngines() {
        return this._sessionEngines;
    }
    get viewportEngines() {
        return this._viewportEngines;
    }
}
exports.StateEngine = StateEngine;
//# sourceMappingURL=StateEngine.js.map